app.controller("NotificationsWindowController", ["$scope", "$uibModalInstance", "params", "AgreementService",
    function ($scope, $uibModalInstance, params, AgreementService) {
        $scope.notification = params.notification;
        $scope.agreement = params.agreement;
        $scope.title = params.notification.title;
        $scope.text = params.notification.text;
        $scope.actionButtonText = params.notification.actionButtonText;

        if($scope.actionButtonText) {
            AgreementService.mark({
                _id: params._id,
                status: 'READ'
            }).then(function () {});
        }

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.submit = function () {
            AgreementService.mark({
                _id: params._id,
                status: 'ACCEPTED'
            }).then(function () {});
        };
    }
]);
